import * as React from 'react';
import { FiSend, FiX } from 'react-icons/fi';
import { cn } from '@/lib/utils';
import tiaAvatar from '@/assets/images/tia/tia-avatar-3d.png';

export function TiaChatBar({ onSubmit, onFocus, onClose, disabled, closing, floating = false, avatar = tiaAvatar }) {
  const [text, setText] = React.useState('');

  const submit = event => {
    event.preventDefault();
    const body = text.trim();
    if (!body || disabled) return;
    onSubmit(body);
    setText('');
  };

  return (
    <form
      onSubmit={submit}
      className={cn(
        !floating && 'c-tia-chat-bar',
        !floating && closing && 'c-tia-chat-bar--closing',
        !floating && 'mt-2',
        'flex min-w-0 flex-1 items-center gap-2 rounded-full px-3 py-2',
        floating ? 'bg-primary' : 'bg-gradient-to-r from-secondary to-primary',
        'shadow-[0_12px_32px_rgba(0,0,0,0.16)]'
      )}
    >
      <img
        src={avatar}
        alt=""
        className={cn('h-10 w-10 rounded-full border-2 border-white/70', avatar !== tiaAvatar && 'border-white bg-white', floating && 'hidden sm:block')}
      />
      <input
        value={text}
        onChange={event => setText(event.target.value)}
        onFocus={onFocus}
        placeholder="Pergunte pra T.I.A..."
        aria-label="Pergunte pra T.I.A"
        maxLength={2000}
        className="min-w-0 flex-1 bg-transparent text-sm font-medium text-white placeholder:text-white/80 focus:outline-none"
      />
      <button
        type="submit"
        disabled={disabled}
        aria-label="Enviar pergunta"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/20 text-white transition-transform active:scale-95 disabled:opacity-50"
      >
        <FiSend size={16} />
      </button>
      <button
        type="button"
        onClick={onClose}
        aria-label="Fechar chat"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-white/80 transition-transform active:scale-95"
      >
        <FiX size={18} />
      </button>
    </form>
  );
}
